// JalurContext.js — Context global untuk menyimpan pilihan jalur (Tamtama/Bintara)
//
// CATATAN MIGRASI KE AKUN (untuk nanti saat backend siap):
// - Ganti localStorage.getItem/setItem dengan API call ke backend
// - Field 'jalurUser' akan jadi kolom di tabel users di database
// - Struktur JALUR_INFO bisa tetap dipakai sebagai referensi UI

import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'jalurUser';

export const JALUR_INFO = {
  tamtama: {
    id: 'tamtama',
    label: 'Tamtama',
    icon: '🔰',
    pendidikan: 'Minimal SMP/SMA sederajat',
    fokus: 'Kapabilitas fisik, taktik tempur perorangan, kerja tim',
    warna: 'green',
  },
  bintara: {
    id: 'bintara',
    label: 'Bintara',
    icon: '🪖',
    pendidikan: 'Minimal SMA/SMK sederajat (nilai rata-rata min. 70)',
    fokus: 'Kepemimpinan regu, manajemen tim, kemampuan analisis & komunikasi',
    warna: 'amber',
  },
};

const JalurContext = createContext(null);

export function JalurProvider({ children }) {
  const [jalur, setJalurState] = useState(null);
  const [loading, setLoading] = useState(true);

  // Baca dari localStorage saat pertama kali app dibuka
  useEffect(() => {
    const tersimpan = localStorage.getItem(STORAGE_KEY);
    if (tersimpan && JALUR_INFO[tersimpan]) {
      setJalurState(tersimpan);
    }
    setLoading(false);
  }, []);

  // Set jalur baru — sekaligus simpan ke localStorage
  const setJalur = (jalurBaru) => {
    if (!JALUR_INFO[jalurBaru]) return;
    localStorage.setItem(STORAGE_KEY, jalurBaru);
    setJalurState(jalurBaru);
  };

  // Reset pilihan (untuk tombol "Ganti Jalur" di Profil)
  const resetJalur = () => {
    localStorage.removeItem(STORAGE_KEY);
    setJalurState(null);
  };

  return (
    <JalurContext.Provider value={{ jalur, setJalur, resetJalur, loading, info: jalur ? JALUR_INFO[jalur] : null }}>
      {children}
    </JalurContext.Provider>
  );
}

export function useJalur() {
  const ctx = useContext(JalurContext);
  if (!ctx) throw new Error('useJalur harus dipakai di dalam JalurProvider');
  return ctx;
}
